import script from "./session-card.vue?vue&type=script&setup=true&lang=js"
export * from "./session-card.vue?vue&type=script&setup=true&lang=js"

import "./session-card.vue?vue&type=style&index=0&id=b505ce44&lang=less&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b505ce44"]])

export default __exports__